import './index.css';

import { initSentry } from 'lib/sentry';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import * as serviceWorker from './serviceWorker';
import { captureAttribution } from './utils/attribution';

initSentry();
// Before React mounts: the auth redirect rewrites the URL and drops the query string.
captureAttribution();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);
serviceWorker.unregister();
